export interface IFilterEvent {
  key: string;
  value: any;
  type: ColumnHeaderFilterType;
}

export enum ColumnHeaderFilterType {
  Text = 'text',
  Date = 'date',
  Range = 'range',
  List = 'list',
  Number = 'number',
  Empty = ''
}
